import { createContext, type ReactNode, useContext } from 'react';
import type { Language } from '@/shared/api';

/**
 * Языки контента инсталляции для полей LocalizedText (COM-09): RU — `['ru']`, World — `['en', 'es']`.
 * Берутся из `GET /admin/config` (`languages`, `content.translation`) — код рынка не сравнивается
 * (ARCH-01). Провайдер ставит слой app; без него поле LocalizedText не знает языков — это ошибка сборки
 * экрана, а не данных.
 */
export interface ContentLanguages {
  languages: readonly Language[];
  /** Второй язык заполняется автопереводом при сохранении (World, D13). */
  autoTranslate: boolean;
}

const ContentLanguagesContext = createContext<ContentLanguages | null>(null);

export function ContentLanguagesProvider({
  value,
  children,
}: {
  value: ContentLanguages;
  children: ReactNode;
}) {
  return (
    <ContentLanguagesContext.Provider value={value}>{children}</ContentLanguagesContext.Provider>
  );
}

export function useContentLanguages(): ContentLanguages {
  const value = useContext(ContentLanguagesContext);
  if (!value)
    throw new Error('ContentLanguagesProvider is missing (языки контента из /admin/config)');
  return value;
}
